import { CustomAxiosRequestConfig, http } from '../../http';
import {
    RequestDeleteDashboardWidget,
    RequestGetDashboardWidget,
    RequestPatchDashboardWigetComment,
    RequestPostDashboardWidget,
    RequestPutDashboardWidget,
    ResponseDeleteDashboardWidget,
    ResponseGetDashboardWidget,
    ResponsePatchDashboardWigetComment,
    ResponsePostDashboardWidget,
    ResponsePutDashboardWidget,
} from './types';

import { __ } from '@/js/stores/expressions';

export const addDashboardWidget = async ({ dashboardId, ...req }: RequestPostDashboardWidget) => {
    const config: CustomAxiosRequestConfig = {
        silent: false,
        errorMessage: {
            404: __('create-new-widget-error-response-404'),
        },
    };
    return http
        .post<RequestPostDashboardWidget, ResponsePostDashboardWidget>(
            `dashboard/${dashboardId}/widget`,
            req,
            config
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error adding dashboard widget:', error);
            throw error;
        });
};

export const updateDashboardWidget = async ({
    widgetId,
    dashboardId,
    ...req
}: RequestPutDashboardWidget) => {
    const config: CustomAxiosRequestConfig = {
        silent: false,
        errorMessage: {
            404: __('create-new-widget-error-response-404'),
        },
    };

    const payload = Object.fromEntries(
        Object.entries(req).filter(([, value]) => value !== null && value !== undefined)
    ) as Omit<RequestPutDashboardWidget, 'dashboardId' | 'widgetId'>;

    return http
        .put<RequestPutDashboardWidget, ResponsePutDashboardWidget>(
            `dashboard/${dashboardId}/widget/${widgetId}`,
            payload,
            config
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error updating dashboard widget:', error);
            throw error;
        });
};

export const getDashboardWidget = async (req: RequestGetDashboardWidget, signal?: AbortSignal) => {
    return http
        .get<RequestGetDashboardWidget, ResponseGetDashboardWidget>(
            `dashboard/${req.dashboardId}/widget/${req.widgetId}`,
            { signal }
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching dashboard widget:', error);
            throw error;
        });
};

export const updateDashboardWidgetComment = async (req: RequestPatchDashboardWigetComment) => {
    return http
        .patch<RequestPatchDashboardWigetComment, ResponsePatchDashboardWigetComment>(
            `dashboard/${req.dashboardId}/widget/${req.widgetId}/update-comment`,
            { comment: req.comment }
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error updating dashboard widget comment:', error);
            throw error;
        });
};

export const deleteDashboardWidget = async (req: RequestDeleteDashboardWidget) => {
    const config: CustomAxiosRequestConfig = {
        silent: false,
        successMessage: __('delete-widget-success', { widgetTitle: req.widgetTitle }),
        errorMessage: {
            404: __('delete-widget-error-response-404', { widgetTitle: req.widgetTitle }),
        },
    };

    return http
        .delete<RequestDeleteDashboardWidget, ResponseDeleteDashboardWidget>(
            `dashboard/${req.dashboardId}/widget/${req.widgetId}`,
            config
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error deleting dashboard widget:', error);
            throw error;
        });
};
